import { render } from "./RegistroCuentaAlumno.vue?vue&type=template&id=6d9e3120&scoped=true"
import script from "./RegistroCuentaAlumno.vue?vue&type=script&lang=js"
export * from "./RegistroCuentaAlumno.vue?vue&type=script&lang=js"

import "./RegistroCuentaAlumno.vue?vue&type=style&index=0&id=6d9e3120&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9e3120"]])

export default __exports__